import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import NumberFormat from 'react-number-format';
import { FormattedMessage } from 'react-intl';
import moment from 'utils/moment';
import { getTotalAmount } from './calculations';
import Status from './Status';
import styles from '../../../styles/general.module.scss';
import sortIcon from '../../../icons/inspection-icons/sort.svg';
import sortActiveIcon from '../../../icons/inspection-icons/sort-active.svg';

const Table = ({ info, price_adjusted, sortKey, sortData, isNetSuite, profile }) => {
  const TotalAmount = (e) => {
    let totalAmount = 0.00;
    let discountAmount = 0.00;
    let creditAmount = 0.00;
    if (e?.id) {
      let amount = getTotalAmount(e.items, price_adjusted);
      discountAmount = parseFloat(e?.discount) || 0;
      creditAmount = parseFloat(e?.credit) || 0;
      amount -= discountAmount;
      amount += creditAmount;
      totalAmount = amount.toString().includes('.') ? amount : `${amount}.00`;
    }
    return totalAmount;
  };

  const aerosimpleColumns = [
    {
      key: 'order_number',
      label: 'INVOICE #',
      id: 'invoice.detail.request.invoiceNumber',
      className: styles.invoiceid
    },
    {
      key: 'logged_by',
      label: 'CREATED BY',
      id: 'invoice.detail.request.createdBy',
      className: styles.createdby
    },
    {
      key: 'invoice_date',
      label: 'INVOICE DATE',
      id: 'invoice.detail.request.invoiceDate',
      className: styles.invoicedate
    },
    {
      key: 'customer',
      label: 'COMPANY NAME',
      id: 'invoice.detail.request.companyName',
      className: styles.companyname
    },
    {
      key: 'amount',
      label: 'INVOICE AMOUNT',
      id: 'invoice.detail.request.invoiceAmount',
      className: styles.invoiceamount
    },
    {
      key: 'payment_due',
      label: 'Payment Due',
      id: 'invoice.detail.request.paymentDue',
      className: styles.invoiceamount
    },
    {
      key: 'status',
      label: 'STATUS',
      id: 'invoice.detail.request.invoiceStatus',
      className: styles.invoicestatus
    }
  ];

  const netSuiteColumns = [
    {
      key: 'tranid',
      label: 'INVOICE #',
      id: 'invoice.detail.request.tranid'
    },
    {
      key: 'trandate',
      label: 'INVOICE DATE',
      id: 'invoice.detail.request.trandate'
    },
    {
      key: 'duedate',
      label: 'DUE DATE',
      id: 'invoice.detail.request.duedate'
    },
    {
      key: 'foreignamountunpaid',
      label: 'AMOUNT DUE',
      id: 'invoice.detail.request.foreignamountunpaid'
    },
    {
      key: 'status',
      label: 'STATUS',
      id: 'invoice.detail.request.status'
    }
  ];

  const columns = isNetSuite ? netSuiteColumns : aerosimpleColumns;

  let tableRows;

  if (!info.length) {
    tableRows = (
      <tr>
        <td className="noTableData" colSpan={isNetSuite ? 5 : 7}>
          <FormattedMessage
            id="invoice.list.table.no_results"
            defaultMessage="No invoices available"
          />
        </td>
      </tr>
    );
  } else if (isNetSuite) {
    tableRows = info.map(e => (
      <tr key={e.id}>
        <td>{e.tranid}</td>
        <td>{e.trandate && moment(e.trandate).format('MM/DD/YYYY')}</td>
        <td>{e.duedate && moment(e.duedate).format('MM/DD/YYYY')}</td>
        <td>
          <NumberFormat
            displayType="text"
            value={e.foreignamountunpaid}
            thousandSeparator
            decimalScale={profile?.portal_airport?.airport_settings?.decimal_precision || 2}
            fixedDecimalScale
            prefix={profile?.urls?.currency || '$'}
          />
        </td>
        <td>{e.status}</td>
      </tr>
    ));
  } else {
    tableRows = info.map(e => (
      <tr key={e.id}>
        <td>{e.order_number}</td>
        <td>{e.logged_by?.fullname}</td>
        <td>{e.invoice_date && moment(e.invoice_date).format('MM/DD/YYYY hh:mm A')}</td>
        <td>{e.customer?.name}</td>
        <td>
          <NumberFormat
            displayType="text"
            value={TotalAmount(e)}
            thousandSeparator
            decimalScale={profile?.portal_airport?.airport_settings?.decimal_precision || 2}
            fixedDecimalScale
            prefix={profile?.urls?.currency || '$'}
          />
        </td>
        <td>{e.payment_due && moment(e.payment_due).format('MM/DD/YYYY hh:mm A')}</td>
        <td><Status item={e.status} /></td>
        <td>
          <Link to={`/invoice/${e.order_number}/detail`}>
            <FormattedMessage id="invoices.list.table.action" defaultMessage="View" />
          </Link>
        </td>
      </tr>
    ));
  }
  return (
  <table className={styles.table}>
    <thead>
      <tr>
        {columns.map(col => (
          <th key={col.key} className={col.className || ''}>
            <FormattedMessage id={col.id} defaultMessage={col.label} />
            <span
              role="button"
              tabIndex={0}
              onClick={() => sortData(col.key)}
              onKeyPress={() => sortData(col.key)}
            >
              <img src={sortKey === col.key ? sortActiveIcon : sortIcon} alt="" />
            </span>
          </th>
        ))}
      </tr>
    </thead>
    <tbody>
      {tableRows}
    </tbody>
  </table>
);
};

Table.propTypes = {
  info: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};
export default Table;
